import Colour from 'components/utils/Colour'
import Group from 'components/utils/Group'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'
import { LUX_PLUS_MONTH_ALL_OFFERS_URL } from '../constants/luxPlusMonthTakeoverConstants'
import LuxPlusMonthCalendarLogo from './LuxPlusMonthCalendarLogo'

interface Props {
  withCta?: boolean
}

function LuxPlusMonthTakeoverOfferBanner({ withCta }: Props) {
  return <Group direction="horizontal" gap={12} verticalAlign="center">
    <LuxPlusMonthCalendarLogo size="S" />
    <BodyText variant="large">
      <b>LuxPlus<Colour value="highlight-lux-plus">+</Colour> Month.</b> More savings, more hidden offers, more exclusive benefits.
      {withCta && <>
        {' '}
        <TextLink to={LUX_PLUS_MONTH_ALL_OFFERS_URL} wrap="no-wrap">View all offers</TextLink>
      </>}
    </BodyText>
  </Group>
}

export default LuxPlusMonthTakeoverOfferBanner
